import { TagMatchingType } from "entities/modules/types";

export const tagMatchingOptions = [
  {
    label: "Equals",
    value: TagMatchingType.EQUALS,
  },
  {
    label: "Not Equals",
    value: TagMatchingType.NOT_EQUALS,
  },
];

export const tagTypeOptions = [
  { value: "themeTag", label: "Theme Tag" },
  { value: "serviceTag", label: "Service Tag" },
  { value: "metadataTag", label: "Metadata Tag" },
];
